<template>
  <div>
    <detail :item="item"></detail>
    <div class="container d-print-none return-to-list">
      <router-link to="/characters"><i class="fa fa-angle-double-left"></i> Return to list</router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Detail from "@/components/character/_Detail";

export default {
  name: "character-show",
  components: {
    Detail
  },
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState({
      item: state => state.characters.current
    })
  },
  methods: {
    ...mapActions({
      charactersRead: "characters/read"
    }),
    async getData() {
      try {
        await this.charactersRead({ id: this.$route.params.id });
        this.$embers.pageData(this.item.name, this.item.description);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
